import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CareTeamMember } from "@/core/types";

import { getCareTeam } from "../queryFunctions/getCareTeam";
import { memberCarePlanKeys } from "../keyFactory";

type UseCareTeamProps<TData = CareTeamMember[]> = {
  patientId: string;
  select?: (data: CareTeamMember[]) => TData;
};

type CareTeamQueryOptions = UseQueryOptions<
  CareTeamMember[],
  unknown,
  CareTeamMember[],
  ReturnType<typeof memberCarePlanKeys.careTeam>
>;

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getCareTeam(patientId),
    queryKey: memberCarePlanKeys.careTeam(patientId),
  } satisfies CareTeamQueryOptions;
}

export function useCareTeam<TData = CareTeamMember[]>({
  patientId,
  select,
}: UseCareTeamProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}
